<template>
  <a-drawer
    :visible="visible"
    :title="'选择用户'"
    :width="'1300'"
    destroyOnClose
    @close="onClose"
  >
    <div class="chooseUser">
      <div class="deptChoose">
        <a-tree
          :tree-data="treeData"
          default-expand-all
          @select="deptClick"
          @expand="onExpand"
          :autoExpandParent="true"
        />
      </div>
      <div class="flexClass">
        <div class="tableClass">
          <div class="inputClass">
            <a-input
              placeholder="用户名称、账号、邮箱"
              v-model="searchValue"
              allow-clear
            ></a-input>
            <a-button type="primary" @click="searchClick">查询</a-button>
          </div>
          <Table
            ref="table"
            :options="userColumns"
            :tableValue="dataList"
            :customSlotOpt="slotOpt"
            :otherOpt="customOtherOpt"
            @change="getUser"
            :scroll="scroll"
            @selectRow="selectRow"
            style="margin-top: 20px"
            :key="key"
          ></Table>
        </div>
        <div class="btn">
          <a-button @click="moveSelectUser('up')">上移</a-button>
          <a-button @click="moveSelectUser('down')">下移</a-button>
          <a-button @click="delClick">删除</a-button>
          <a-button @click="clearClick">清空</a-button>
        </div>
      </div>
      <div class="choose">
        <div>已选择</div>
          <a-checkbox-group v-model="checkedList" @change="checkChange">
            <a-checkbox
              :value="item.id"
              v-for="item in plainOptions"
              :key="item.id"
              >{{ item.userName }}</a-checkbox
            >
          </a-checkbox-group>
      </div>
    </div>
    <div class="footer-but">
      <a-button style="margin-right: 8px" @click="onClose"> 取消 </a-button>
      <a-button class="first-but" type="primary" @click="addClick">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { userColumns } from '../config'
import { countTreeselect, addUserRole } from '@/api/role'
import { getDeptData } from '@/api/back'
import Table from '@/views/Back/components/table/index.vue'
export default {
  props: {
    visible: Boolean,
    rows: Object
  },
  data () {
    return {
      searchValue: '',
      treeData: [],
      slotOpt: [],
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      scroll: { x: 500, y: 1000 },
      userColumns,
      dataList: [],
      deptId: '',
      defaultExpandAll: true,
      expandedKeys: [],
      autoExpandParent: true,
      checkedList: [], // 选择的用户
      checkedListCopy: [], // 被选中的用户
      plainOptions: [],
      plainOptionsCopy: [],
      key: 1
    }
  },
  components: { Table },
  watch: {
    visible (val) {
      if (val) {
        this.checkedList = []
        this.plainOptions = []
        this.getDeptTree()
      }
    }
  },
  methods: {
    async addClick () {
      if (this.checkedList.length === 0) {
        this.$message.warning('请先选择后再确定!')
        return
      }
      let params = {
        id: this.rows.roleId,
        ids: this.checkedList
      }
      let res = await addUserRole(params)
      if (res.code === 200) {
        this.$message.success('新增成功!')
        this.onClose()
        this.$emit('updateList')
      } else {
        this.$message.warning(res.msg)
      }
    },
    selectRow (val) {
      val.forEach(item => {
        if (this.plainOptions.every(ele => ele.id !== item.id)) {
          this.plainOptions.push(item)
          this.plainOptionsCopy.push(item)
          this.checkedList.push(item.id)
        }
      })
    },
    checkChange (val) {
      let arr = []
      val.forEach(item => {
        this.plainOptions.forEach(ele => {
          if (item === ele.id) {
            arr.push(ele)
          }
        })
      })
      this.plainOptionsCopy = arr
    },
    // 上下移动
    moveSelectUser (direct) {
      if (direct == 'up') {
        this.plainOptionsCopy.forEach(m => {
          let index = this.plainOptions.indexOf(m, 1)
          if (index > 0) {
            let newAry = [...this.plainOptions]
            newAry[index - 1] = this.plainOptions[index]
            newAry[index] = this.plainOptions[index - 1]
            this.plainOptions = newAry
          }
        })
      } else if (direct == 'down') {
        for (var i = this.plainOptionsCopy.length - 1, m; (m = this.plainOptionsCopy[i--]);) {
          let index = this.plainOptions.indexOf(m, 0)
          if (index > -1 && index < this.plainOptions.length - 1) {
            let newAry = [...this.plainOptions]
            newAry[index + 1] = this.plainOptions[index]
            newAry[index] = this.plainOptions[index + 1]
            this.plainOptions = newAry
          }
        }
      }
    },
    // 删除
    delClick () {
      if (this.plainOptions.length > 0) {
        for (let j = 0; j < this.checkedList.length; j++) {
          for (let i = 0; i < this.plainOptions.length; i++) {
            if (this.plainOptions[i].id === this.checkedList[j]) {
              this.plainOptions.splice(i, 1)
              i = i - 1
            }
          }
        }
      }
      let arr = []
      this.plainOptions.forEach(res=>{
        arr.push(res.id)
      })
      this.$refs.table.selectedRowIds = arr
      this.$refs.table.selectedRowKeys = arr
    },
    clearClick () {
      this.$refs.table.selectedRowKeys = []
      this.$refs.table.selectedRowIds = []
      this.plainOptions = []
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    searchClick () {
      let form = {
        userName: this.searchValue,
        email: this.searchValue,
        nickName: this.searchValue,
        deptId: ''
      }
      this.getUser('', form)
    },
    deptClick (val) {
      this.key++
      this.$refs.table.pagination.pageNum = 1
      this.$refs.table.pagination.current = 1
      this.deptId = val[0]
      this.getUser()
    },
    async getDeptTree () {
      let res = await countTreeselect()
      res.data.forEach(item => {
        this.common(item)
      })
      this.treeData = res.data
      this.deptId = res.data[0].id
      this.getUser()
    },

    async getUser (val, form) {
      let params = {
        ...this.handlerBeforeRequestParams(),
        deptId: this.deptId,
        ...form,
      }
      let res = await getDeptData(params)
      this.dataList = res.rows
      this.dataList.forEach((item, key) => {
        item.key = key + 1
      })
      this.customOtherOpt.pagination.total = res.total
    },
    handlerBeforeRequestParams () {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        pageNum,
        pageSize
      }
      return params
    },
    common (item) {
      item.key = item.id
      item.title = item.label
      if (item.children && item.children.length > 0) {
        this.filedChange(item.children)
      }
    },
    filedChange (val) {
      val.forEach(item => {
        this.common(item)
      })
    },
    onClose () {
      this.$emit('ok')
    },

  }
}
</script>